window.DSWishlist = (function () {
  var KEY = 'ds_wishlist';

  function getList() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function has(h) { return getList().indexOf(h) > -1; }
  function toggle(h) {
    var l = getList(), i = l.indexOf(h);
    if (i === -1) { l.push(h); } else { l.splice(i, 1); }
    localStorage.setItem(KEY, JSON.stringify(l));
    return i === -1;
  }
  function count() { return getList().length; }

  function updateBadges() {
    document.querySelectorAll('.ds-wish-badge').forEach(function (b) {
      var c = count();
      b.textContent = c;
      b.style.display = c > 0 ? 'flex' : 'none';
    });
  }

  function updateButtons() {
    document.querySelectorAll('[data-wish-handle]').forEach(function (btn) {
      var active = has(btn.getAttribute('data-wish-handle'));
      btn.classList.toggle('ds-wish-active', active);
      btn.setAttribute('aria-label', active ? 'Retirer des favoris' : 'Ajouter aux favoris');
      var p = btn.querySelector('path');
      if (p) p.style.fill = active ? '#D1AFA3' : 'none';
    });
  }

  function heartSVG() {
    return '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"'
      + ' stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
      + '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06'
      + 'a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06'
      + 'a5.5 5.5 0 0 0 0-7.78z"/></svg>';
  }

  function badgeSpan() {
    return '<span class="ds-wish-badge" style="'
      + 'display:none;position:absolute;top:-4px;right:-4px;'
      + 'background:#D1AFA3;color:white;font-size:9px;'
      + 'width:16px;height:16px;border-radius:50%;'
      + 'align-items:center;justify-content:center;'
      + 'font-weight:bold;pointer-events:none;"></span>';
  }

  var injectTimer;
  function injectHeaderIcon() {
    clearTimeout(injectTimer);
    injectTimer = setTimeout(function () {
      if (document.getElementById('ds-wish-header')) return;

      var stickyHeader =
        document.querySelector('sticky-header') ||
        document.querySelector('header[role="banner"]') ||
        document.querySelector('header');
      if (!stickyHeader) return;

      var cartEl =
        stickyHeader.querySelector('cart-drawer-opener') ||
        stickyHeader.querySelector('a[href="/cart"]');
      if (!cartEl) return;

      var cartItem = cartEl;
      if (cartEl.parentElement && cartEl.parentElement.tagName === 'LI') {
        cartItem = cartEl.parentElement;
      }
      var container = cartItem.parentElement;
      if (!container) return;

      var cartCS = window.getComputedStyle(cartItem);
      var heartEl;

      if (cartItem.tagName === 'LI') {
        heartEl = document.createElement('li');
        heartEl.className = cartItem.className;

        var innerRef = cartEl.querySelector('button, a') || cartEl;
        var link = document.createElement('a');
        link.id = 'ds-wish-header';
        link.href = '/pages/favoris';
        link.className = innerRef.className || '';
        link.setAttribute('aria-label', 'Mes favoris');
        link.style.cssText = [
          'display:inline-flex',
          'align-items:center',
          'justify-content:center',
          'align-self:center',
          'position:relative',
          'text-decoration:none',
          'color:inherit',
          'cursor:pointer',
          'height:' + cartCS.height,
          'width:' + cartCS.width,
          'padding:' + cartCS.padding
        ].join(';');
        link.innerHTML = heartSVG() + badgeSpan();
        heartEl.appendChild(link);

      } else {
        heartEl = document.createElement('a');
        heartEl.id = 'ds-wish-header';
        heartEl.href = '/pages/favoris';
        heartEl.setAttribute('aria-label', 'Mes favoris');
        heartEl.style.cssText = [
          'display:inline-flex',
          'align-items:center',
          'justify-content:center',
          'align-self:center',
          'position:relative',
          'text-decoration:none',
          'color:inherit',
          'cursor:pointer',
          'height:' + cartCS.height,
          'width:' + cartCS.width,
          'padding:' + cartCS.padding,
          'box-sizing:border-box'
        ].join(';');
        heartEl.innerHTML = heartSVG() + badgeSpan();
      }

      container.insertBefore(heartEl, cartItem);
      updateBadges();
    }, 300);
  }

  function renderWishlistPage() {
    var container = document.getElementById('ds-wishlist-container');
    if (!container) return;
    var list = getList();
    if (list.length === 0) {
      container.innerHTML =
        '<div style="text-align:center;padding:60px 20px;">'
        + '<p style="color:#9B8E7E;font-size:16px;margin-bottom:24px;">'
        + "Vous n'avez pas encore de favoris.</p>"
        + '<a href="/" style="display:inline-block;padding:12px 32px;'
        + 'background:#1A1512;color:white;text-decoration:none;'
        + 'font-size:13px;letter-spacing:0.1em;text-transform:uppercase;">'
        + 'D\u00e9couvrir la boutique</a></div>';
      return;
    }
    var grid = document.createElement('div');
    grid.style.cssText =
      'display:grid;grid-template-columns:repeat(auto-fill,minmax(220px,1fr));gap:24px;';
    container.innerHTML = '';
    container.appendChild(grid);
    list.forEach(function (handle) {
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var price = (p.price / 100).toFixed(2).replace('.', ',');
          var card = document.createElement('div');
          card.style.position = 'relative';
          card.setAttribute('data-wish-card', handle);
          card.innerHTML =
            '<a href="' + p.url + '" style="text-decoration:none;color:inherit;display:block;">'
            + (p.featured_image
              ? '<img src="' + p.featured_image + '" alt="' + p.title
                + '" loading="lazy" style="width:100%;aspect-ratio:3/4;object-fit:cover;display:block;">'
              : '')
            + '<div style="padding:10px 0 4px;">'
            + '<p style="font-size:13px;font-weight:500;color:#1A1512;margin:0 0 4px;">'
            + p.title + '</p>'
            + '<p style="font-size:13px;color:#B8895A;margin:0;">'
            + price + ' \u20ac</p></div></a>'
            + '<button data-wish-handle="' + handle + '" aria-label="Retirer des favoris"'
            + ' style="position:absolute;top:10px;right:10px;background:white;border:none;'
            + 'border-radius:50%;width:32px;height:32px;display:flex;align-items:center;'
            + 'justify-content:center;cursor:pointer;box-shadow:0 1px 4px rgba(0,0,0,0.15);">'
            + '<svg width="16" height="16" viewBox="0 0 24 24" fill="#D1AFA3" stroke="#D1AFA3"'
            + ' stroke-width="2" stroke-linecap="round" stroke-linejoin="round">'
            + '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06'
            + 'a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06'
            + 'a5.5 5.5 0 0 0 0-7.78z"/></svg></button>';
          grid.appendChild(card);
        });
    });
  }

  function init() {
    updateBadges();
    updateButtons();
    injectHeaderIcon();
    setTimeout(injectHeaderIcon, 800);
    setTimeout(injectHeaderIcon, 2200);

    var t;
    window.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        if (!document.getElementById('ds-wish-header')) injectHeaderIcon();
      }, 200);
    }, { passive: true });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wish-handle]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      toggle(btn.getAttribute('data-wish-handle'));
      updateBadges();
      updateButtons();
      if (window.location.pathname.includes('favoris')) {
        var card = btn.closest('[data-wish-card]');
        if (card) card.remove();
      }
    });

    if (window.location.pathname.includes('favoris')) renderWishlistPage();
  }

  return { init: init, getList: getList, has: has, count: count };
})();

document.addEventListener('DOMContentLoaded', function () { DSWishlist.init(); });
